// src/redux/reducers/homeSlice.js

import { createSlice } from '@reduxjs/toolkit';
import { fetchEventStatusData } from '../actions/eventsAction';
import { fetchEvents } from '../thunks/fetchEvents';

const initialState = {
  eventList: [],
  eventListFilter: [],
  load: false,
  selectedMatchStatus: "All",
  isMouseOverInput: false,
  eventModal: false,
  showWindow: false,
  confirm: "",
  selectId: null,
  selectedDate: null,
  selectedMonth: new Date(),
  selectedMonthName: new Date().getMonth() + 1,
  selectedYear: new Date().getFullYear(),
  selectedEventGroup: "All",
  reLoadData: false,
  mergedEventData: [],
  userRole: "All",
  locationSearchText: "",
  selectedGroups: [],
  selectedCheckboxes: {},
  searchText: "",
  selectedItems: [],
  loading: false,
  error: null,
  eventStatusData: [],
  matchStatusOptions: [],
  fetchEventsLoading: false,
  fetchEventsError: null


};

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setEventList(state, action) {
      state.eventList = action.payload;
    },
    setEventListFilter(state, action) {
      state.eventListFilter = action.payload;
    },
    setLoad(state, action) {
      state.load = action.payload;
    },
    setSelectedMatchStatus(state, action) {
      state.selectedMatchStatus = action.payload;
    },
    setIsMouseOverInput(state, action) {
      state.isMouseOverInput = action.payload;
    },
    setEventModal(state, action) {
      state.eventModal = action.payload;
    },
    setShowWindow(state, action) {
      state.showWindow = action.payload;
    },
    setConfirm(state, action) {
      state.confirm = action.payload;
    },
    setSelectId(state, action) {
      state.selectId = action.payload;
    },
    setSelectedDate(state, action) {
      state.selectedDate = action.payload;
    },
    setSelectedMonth(state, action) {
      state.selectedMonth = action.payload;
    },
    setSelectedMonthName(state, action) {
      state.selectedMonthName = action.payload;
    },
    setSelectedYear(state, action) {
      state.selectedYear = action.payload;
    },
    setPreviousDay(state) {
      if(state.selectedDate){
        const newDate = new Date(state.selectedDate);
        newDate.setDate(newDate.getDate() - 1);
        state.selectedDate = newDate;
      }
    },
    setNextDay(state) {
      if(state.selectedDate){
        const newDate = new Date(state.selectedDate);
        newDate.setDate(newDate.getDate() + 1);
        state.selectedDate = newDate;
      }
    },
    setSelectedEventGroup(state, action) {
      state.selectedEventGroup = action.payload;
    },
    setReLoadData(state, action) {
      state.reLoadData = action.payload;
    },
    setMergedEventData(state, action) {
      state.mergedEventData = action.payload;
    },
    setUserRole(state, action) {
      state.userRole = action.payload;
    },
    setLocationSearchText(state, action) {
      state.locationSearchText = action.payload;
    },
    setSelectedGroups(state, action) {
      state.selectedGroups = action.payload;
    },
    setSelectedCheckboxes(state, action) {
      state.selectedCheckboxes = action.payload;
    },
    setSearchText(state, action) {
      state.searchText = action.payload;
    },
    setSelectedItems(state, action) {
      state.selectedItems = action.payload;
    },
    clearFetchEventsError: (state) => {
      state.fetchEventsError = null;
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEventStatusData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEventStatusData.fulfilled, (state, action) => {
        state.loading = false;
        state.eventStatusData = action.payload.eventStatusData;
        state.matchStatusOptions = action.payload.statusOptions;
      })
      .addCase(fetchEventStatusData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchEvents.pending, (state) => {
        state.fetchEventsLoading = true;
        state.fetchEventsError = null;
      })
      .addCase(fetchEvents.fulfilled, (state, action) => {
        state.fetchEventsLoading = false;
        state.fetchEventsError = null;
        state.eventList = action.payload.DATA;
        state.fetchEventsError = action.payload.ERROR;
      })
      .addCase(fetchEvents.rejected, (state, action) => {

        state.fetchEventsLoading = false;
        state.fetchEventsError = action.payload || 'An error occurred while fetching events';
      });
  },
});

export const {
  setEventList,
  setEventListFilter,
  setLoad,
  setSelectedMatchStatus,
  setIsMouseOverInput,
  setEventModal,
  setShowWindow,
  setConfirm,
  setSelectId,
  setSelectedDate,
  setSelectedEventGroup,
  setReLoadData,
  setMergedEventData,
  setUserRole,
  setLocationSearchText,
  setSelectedGroups,
  setSelectedCheckboxes,
  setSearchText,
  setSelectedItems,
  setSelectedMonth,
  setPreviousDay,
  setNextDay,
  setSelectedYear,
  setSelectedMonthName,
  clearFetchEventsError

} = homeSlice.actions;

export default homeSlice.reducer;